import initLoanAppStore from '../config/store';
import initSelfServiceStore from '../config/store.ss';
import initUnifiedStore from '../config/store.unified';

function initStore() {
  if (UNIFIED_APP) {
    return initUnifiedStore();
  }

  if (SELF_SERVICE) {
    return initSelfServiceStore();
  }

  return initLoanAppStore();
}

export default initStore();
